import { Button } from '../input';
import { useGlobal } from '../../state';

export const CtaButtons = () => {
  const { apiKey, host } = useGlobal();
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 40 }}>
      <Button large style={{ width: 220 }} outline href="https://docs.fetchfox.ai/">
        Docs
      </Button>
      <Button large style={{ width: 220 }} to="/dashboard">
        {apiKey ? 'Dashboard »' : 'Get API Key'}
      </Button>
    </div>
  );
};
